import React from "react";

import Nav from "./base/nav";
import NavigationDropdown from "./navigation-dropdown";
import NavigationDropdownLink from "./navigation-dropdown-link";
import NavigationLink from "./navigation-link";
import { useContentContext } from "../context/content-context";

const Navigation = ({ variant }) => {
  const { primaryMenuItems, footerMenuItems, isHCP } = useContentContext();

  const items =
    variant === "footer" && isHCP ? footerMenuItems : primaryMenuItems;

  const VARIANT_STYLES = {
    footer: {
      flexDirection: isHCP ? "column" : ["column", "row", "row"],
      flexWrap: "wrap",
      width: isHCP ? "100%" : ["75%", "75%", "100%"],
      justifyContent: "flex-start",
      className: "nav-container",
      items: footerMenuItems,
    },
    navigation: {
      flexDirection: "row",
      marginBottom: 0,
      justifyContent: "flex-end",
      alignItems: "flex-end",
      width: "100%",
      items: primaryMenuItems,
    },
    mobileNavigation: {
      flexDirection: "column",
      marginBottom: "42px",
      items: primaryMenuItems,
    },
  };

  return (
    <Nav display="flex" {...VARIANT_STYLES[variant]}>
      {items.map(({ title, url, items }) => {
        if (items.length > 0) {
          return (
            <NavigationDropdown key={title} variant={variant} title={title}>
              {items.map(({ title, url }) => (
                <NavigationDropdownLink key={title} variant={variant} to={url}>
                  {title}
                </NavigationDropdownLink>
              ))}
            </NavigationDropdown>
          );
        }
        return (
          <NavigationLink key={title} variant={variant} to={url}>
            {title}
          </NavigationLink>
        );
      })}
    </Nav>
  );
};

export default Navigation;
